export const getFullResponse = ({
  observeInput,
  feelInput,
  needInput,
  offerInput,
  requestInput,
}) => {
  return `${observeInput} As a result of what I noticed, I feel ${feelInput}. In order to move forward, I need ${needInput}. ${offerInput} ${requestInput}`;
};
